import React from 'react';
import styled  from 'styled-components';
import { breakpoints } from '@/layouts/breakpoints';

const StyledComp = styled.div`
  width: 100vw;
  height: 60vh;
  overflow: hidden;
  position: relative;
  padding: 40px;
  border-bottom: 1px solid rgba(var(--greyr), 0.3);
  display: flex;
  align-items: flex-end;

  .graphic {
    overflow: hidden;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.15;
    z-index: 1;
    video{
        width: 100%;
        height: auto;
        min-height: 100%;
        object-fit: cover;
    }
  }

  .content {
    position: relative;
    z-index: 2;
    pointer-events: none;
    max-width: 1400px;
    width: 100%;
    margin: 0 auto;

    h1 {
      font-size: 72px;
      line-height: 1.1;
      margin-bottom: 32px;
      color: var(--black);
    }

    p {
      font-size: 20px;
      color: var(--grey);
      line-height: 1.6;
      max-width: 600px;
      padding-bottom: 12px;
    }
  }

  @media (max-width: 1024px) {
      padding: 30px 20px;
      height: 50vh;

     .content h1 {
      font-size: 48px;
    }
  }

  @media (max-width: ${breakpoints.small}) {
      width: calc(100vw - 32px);
      height: 80vh;
      padding-bottom: 20vh;
  }


  @media (max-width: ${breakpoints.xsmall}) {
    padding: 20px 16px;
    height: auto;
    min-height: 40vh;

    .content {
      h1 {
        font-size: 32px;
        margin-bottom: 20px;
      }

      p {
        font-size: 14px;
      }
    }
  }



`;

const Comp = ({isVisible}) => {
  return (
    <StyledComp>
      <div className="graphic" aria-hidden="true">
        {isVisible &&
          <video
              src="https://cdn.studio14a.com/axion/about.mp4"
              autoPlay
              muted
              loop
              playsInline
            />

        }
      </div>

      <div className="content">
        <h1 className="serif">
          The Modern Financial <br/>Research Platform.
        </h1>

             </div>
    </StyledComp>
  );
};

export default Comp;
